

import React, { useEffect, useState } from "react";

const CustomCursor = ({ disabled = false }) => {
  const [systemCursor, setSystemCursor] = useState(false);
  const [cursorColor, setCursorColor] = useState("rgba(0, 64, 152, 1)");
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect touch device
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    setIsMobile(isTouchDevice);
  }, []);

  useEffect(() => {
    if (disabled || isMobile) return;

    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });

      let el = document.elementFromPoint(e.clientX, e.clientY);
      if (!el) return;

      const ignore = Boolean(el.closest('[data-ignore-cursor="true"]'));
      setSystemCursor(ignore);
      if (ignore) return;

      let target = el;
      while (
        target &&
        getComputedStyle(target).backgroundColor === "rgba(0, 0, 0, 0)"
      ) {
        target = target.parentElement;
      }

      const bg = target ? getComputedStyle(target).backgroundColor : "";

      let color = "rgba(0, 64, 152, 1)";

      if (bg.includes("188, 226, 245")) {
        color = "rgba(25, 175, 225, 1)";
      } else if (bg.includes("0, 64, 152")) {
        color = "rgba(188, 226, 245, 1)";
      }

      setCursorColor(color);
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [disabled, isMobile]);

  // ❌ Disable completely on mobile
  if (disabled || isMobile) return null;

  return (
    <>
      <style>{`
        body {
          cursor: ${systemCursor ? "auto" : "none"} !important;
        }

        a, button, input, textarea {
          cursor: ${systemCursor ? "auto" : "none"} !important;
        }
      `}</style>

      {!systemCursor && (
        <div
          style={{
            position: "fixed",
            top: position.y,
            left: position.x,
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            backgroundColor: cursorColor,
            pointerEvents: "none",
            transform: "translate(-50%, -50%)",
            transition: "background-color 0.2s ease",
            zIndex: 9999,
          }}
        />
      )}
    </>
  );
};

export default CustomCursor;